export const words = [
  "PR",
  "Fintech",
  "Biotech",
  "Data",
  "Wellbeing",
  "Content Production",
];
